import { BasicClient } from '@/utils/httpClient'
import { mutation } from '@/helpers/globalObservable'

const basic = BasicClient.axiosInstance
let countReferer = null

basic.interceptors.response.use((config) => {
  if (countReferer !== null) {
    clearInterval(countReferer)
  }
  // Solo crear timer si NO estamos en iframe
  const timer = createCountTimer()
  if (timer !== null) {
    countReferer = timer
  }
  return Promise.resolve(config)
})

function updateCountReferer () {
  countReferer = createCountTimer()
  return countReferer
}

function closeSweetAlerts() {
  const swalContainers = document.querySelectorAll('.swal2-container');
  swalContainers.forEach(swal => {
    const event = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    swal.dispatchEvent(event);
  });
}

function createCountTimer() {
  // No crear timer de inactividad si estamos en iframe
  // El keep-alive automático maneja la sesión
  try {
    if (window.self !== window.top) {
      console.log('🔄 Iframe detectado - Timer de inactividad deshabilitado (keep-alive activo)')
      return null
    }
  } catch (e) {
    // Error de acceso cross-origin = definitivamente es iframe
    return null
  }
  
  if (!checkSessionExists()) {
    return null
  }

  const startTime = new Date().getTime()
  const limitTime = startTime + 1000 * 60 * 19 //* 19
  return setInterval(() => {
    if(new Date().getTime() >= limitTime) {
      closeSweetAlerts()
      mutation.setActiveTimerModal(true)
      clearInterval(countReferer)
    }
  }, 1000 * 60)
}

function checkSessionExists() {
  const jwt = localStorage.getItem('jwt')
  return jwt && jwt.trim() !== '' && jwt !== 'null' && jwt !== 'undefined'
}

function killCountReferer() {
  clearInterval(countReferer)
  countReferer = null
}

export {
  killCountReferer,
  updateCountReferer
}